import { render, staticRenderFns } from "./InsLogoGather.vue?vue&type=template&id=462aa44c&scoped=true&"
import script from "./InsLogoGather.vue?vue&type=script&lang=ts&"
export * from "./InsLogoGather.vue?vue&type=script&lang=ts&"
import style0 from "./InsLogoGather.vue?vue&type=style&index=0&id=462aa44c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "462aa44c",
  null
  
)

export default component.exports